import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import config from '../config';

const { desktopMinWidth } = config

// Props
// 0) status (fail / success) 
// 1) visible (boolean)
// 2) title
// 3) content
// 4) onClickConfirm (function)

class Modal extends React.Component {

  /* Rendering function */
  render() {
    /* If visible, render component */
    if (this.props.visible === true) {
      return (this.modalComponent())
    }
    /* else, render nothing */
    else {
      return <></>
    }
  }

  /* Modal component */
  modalComponent = () => {
    // Thumb up / down icon and theme color decision
    let Icon = null, themeColor = null;
    if (this.props.status === true) {
      Icon = this.SuccessIcon;
      themeColor = 'var(--success-color)';
    } else {
      Icon = this.ErrorIcon;
      themeColor = 'var(--error-color)'
    }
    return (
      <div>
        {/* Overlay */}
        <this.Overlay onClick={this.props.onClickConfirm} />
        {/* Modal */}
        <this.ModalWindowWrapper>
          <this.ModalWindow>
            {/* Thump up / down icon */}
            <Icon />
            {/* title */}
            <this.Title style={{color: themeColor}}> {this.props.title} </this.Title>

            {/* Content */}
            <this.Content> {this.props.content} </this.Content>

            {/* Confirm button */}
            <this.ConfirmButton
              style={{ backgroundColor: themeColor }}
              onClick={this.props.onClickConfirm}>
              Confirm
            </this.ConfirmButton>
          </this.ModalWindow>
        </this.ModalWindowWrapper>
      </div>
    );
  };

  /* status 가 success 일 경우 테마 */
  successTheme = {
    Icon: this.SuccessIcon,
    color: 'var(--success-color)',
  }

  /* status 가 error 일 경우 테마 */
  errorTheme = {
    Icon: this.ErrorIcon, 
    color: 'var(--error-color)',
  }

  /* Style components */
  // 모달 주위의 어두운 배경
  Overlay = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
  `;
  ModalWindowWrapper = styled.div`
    /* z-index 를 이용해서 modal window 를 화면 방향 앞으로 가져온다 */
    z-index: 2;
    position: fixed;
    width: 100%;
    left: 50%;
    top: 20%;
    margin-left: -50%;
    /* PC 버전 */
    @media only screen and (min-width: ${desktopMinWidth}) {
      margin-left: -288px;
      width: 576px;
   }
  `;
  ModalWindow = styled.div`
    z-index: 2;
    border: 1px solid #888;
    border-radius: 16px;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.38);
    background-color: #fafafa;
    margin: 0 16px;
    /* PC 버전 */
    @media only screen and (min-width: ${desktopMinWidth}) {
      margin: 0;
   }
  `;
  SuccessIconSvg = styled.svg`
    margin-top: 28px;
    width: 80px;
    height: 80px;
    filter: var(--success-svg-filter);
  `;
  ErrorIconSvg = styled.svg`
    margin-top: 28px;
    width: 80px;
    height: 80px;
    filter: var(--error-svg-filter);
  `;
  SuccessIcon = () => <this.SuccessIconSvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z"/>
    <path d="M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"/>
  </this.SuccessIconSvg>
  ErrorIcon = () => <this.ErrorIconSvg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z" />
    <path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z" />
  </this.ErrorIconSvg>
  Title = styled.div`
    margin-top: 24px;
    margin-left: 32px;
    margin-right: 32px;
    text-align: center;
    font-family: var(--font);
    font-weight: 300;
    font-size: 24px;
    line-height: 1;
  `;
  Content = styled.div`
    margin-top: 12px;
    margin-left: 32px;
    margin-right: 32px;
    font-family: var(--font);
    font-weight: 300;
    font-size: 16px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.6);
  `;
  ConfirmButton = styled.button`
    margin-top: 28px;
    margin-bottom: 32px;
    width: 228px;
    height: 48px;
    font-family: var(--font);
    font-size: 16px;
    color: #FFFFFF;
    border-radius: 4px;

    cursor: pointer;
    outline: none;
    border: none;
    -webkit-tap-highlight-color: transparent;
  `;
}

/* Property types of Modal component */
Modal.propTypes = {
  status: PropTypes.bool,
  visible: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  onClickConfirm: PropTypes.func
}

/* Default property of Modal component */
Modal.defaultProps = {
  status: false,
  visible: true,
  title: "Title",
  content: "Content",
  onClickConfirm: () => { }
}

export default Modal;